// @flow
import {
	SET_ACTIVE_TAB,
	OPEN_USER_PROFILE_SIDEBAR,
	CLOSE_USER_PROFILE_SIDEBAR,
	SET_CONVERSATION_NAME_IN_OPEN_CHAT,
	SET_LAYOUT_MODE,
	SET_Profile_LAYOUT_MODE,Get_Profile_LAYOUT_MODE
} from "./constants";

const INIT_STATE = {
	activeTab : "chat",
	userSidebar : false,
	conversationName : "Doris Brown",
	layoutMode : "light",
	ProfileImageChange : null
};

const Layout = (state = INIT_STATE, action) => {
	switch (action.type) {
		case SET_ACTIVE_TAB:
			return {
				...state,
				activeTab: action.payload
			};

		case OPEN_USER_PROFILE_SIDEBAR:
			return {
				...state,
				userSidebar: true
			};

		case CLOSE_USER_PROFILE_SIDEBAR:
			return {
				...state,
				userSidebar: false
			};

		case SET_CONVERSATION_NAME_IN_OPEN_CHAT:
			return {
				...state,
				conversationName: action.payload
			};

		case SET_LAYOUT_MODE:
		return {
			...state,
			layoutMode: action.payload
		};

		case SET_Profile_LAYOUT_MODE:
		return {
			...state,
			ProfileImageChange: action.payload
		};
		case Get_Profile_LAYOUT_MODE:
		return {
			...state,
			ProfileImageChange: action.payload
		}
		default:
			return state;
	}
};

export default Layout;
